<template>
  <div>
    <div class="mass-action-settings">

      <div>
        <cards-stage-select
          v-model="actionData.stageType"
          size="small"
          @change="onStageChange"
        ></cards-stage-select>
      </div>

      <div class="card-stages" style="margin-top: 20px">
        <div class="card-edit-dialog-stage stage">
          <div class="card-edit-dialog-stage-content">
            <stage-item
              v-if="actionData.stage.type"
              :stage="actionData.stage"
              :show-stage-name="false"
              :hide-stage-dates="$companyConfiguration.cardStages.getStageConfig(actionData.stageType).hideDates"
              :show-negotiations-dates="!!$companyConfiguration.cardStages.getStageConfig(actionData.stageType).showNegotiationsDates"
              @negotiation-deleted="negotiationDeleted(actionData.stage, $event)"
            >
            </stage-item>
          </div>
        </div>
      </div>



      <div style="margin-top: 20px;">
        <el-popconfirm
          confirm-button-text='Да'
          cancel-button-text='нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите создать этап?"
          @confirm="doAction"
        >
          <el-button
            slot="reference"
            size="small"
            type="primary"
            :disabled="!actionData.stage"
          >
            Создать
          </el-button>

        </el-popconfirm>
      </div>

    </div>

    <mass-action-result
      v-if="result"
      :result="result"
    ></mass-action-result>
  </div>
</template>

<script>
import {ActionTemplateMixin} from "@/components/massActions/actionTemplates/ActionTemplateMixin";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect.vue";
import MassActionResult from "@/components/massActions/MassActionResult.vue";
import StageItem from "@/components/cards/CardStagesBlock/StageItem.vue";

export default {
  name: "card-create-stage-action",
  mixins: [ActionTemplateMixin],
  components: { StageItem, MassActionResult, CardsStageSelect},

  data() {
    return {
      actionData: {
        stageType: null,
        stage: {},
      }
    }
  },
  methods: {
    onStageChange(){
      let defaultNegotiations = [];
      for (const [index, negotiationType] of Object.entries(this.$companyConfiguration.cardStageNegotiations.getNegotiationTypesForStage(this.actionData.stageType))) {
        defaultNegotiations.push({
          type: negotiationType,
          permissions: {
            [this.$permissions.CARD_STAGE_NEGOTIATION.MOVE]: {can: true, rulesPass: true, errors: []},
            [this.$permissions.CARD_STAGE_NEGOTIATION.DELETE]: {can: true, rulesPass: true, errors: []},
          }
        });
      }

      this.actionData.stage = {
        type: this.actionData.stageType,
        date_start: null,
        date_end: null,
        permissions: {
        [this.$permissions.CARD_STAGE_NEGOTIATION.CREATE]: {can: true, rulesPass: true, errors: []},
        [this.$permissions.CARD_STAGE.SET_DATE]: {can: true, rulesPass: true, errors: []},
        },
        negotiations: defaultNegotiations,
      };
    },
    negotiationDeleted(stage, {negotiationIndex, negotiation}) {
      stage.negotiations.splice(negotiationIndex, 1);
    },
  },
}
</script>
